import { CallinScript } from "../../../powerbroker/src/CallinScript";
import { Button, DataHeader, DataSource, Label, Layout, Panel, Step, Stepper, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCallinScriptStepper extends Layout {
    buttonAddPrompt: Button;
    buttonCallinsUser: Button;
    buttonCancelEdit: Button;
    buttonContinue: Button;
    buttonDelete: Button;
    buttonSaveEdits: Button;
    dataheaderCallinScriptStepper: DataHeader;
    labelAddedPrompts: Label;
    labelLabel1: Label;
    labelLoadDetails: Label;
    labelLoadStatus: Label;
    labelP: Label;
    labelPromptDetails: Label;
    labelTemplateDetails: Label;
    labelUsers: Label;
    layoutCallinScript: CallinScript;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panelAdd: Panel;
    panelDetails: Panel;
    panelFirstPromptDetails: Panel;
    panelLoadDetails: Panel;
    panelLoadStatus: Panel;
    panelMainSummary: Panel;
    panelPromptDetails: Panel;
    panelResponsibility: Panel;
    panelSecondPromptDetails: Panel;
    panelUpdate: Panel;
    panelUsers2: Panel;
    panelUsers: Panel;
    sourceAgencyLink: DataSource;
    sourceCallinScriptTemplate: DataSource;
    sourceCallinScriptTemplateDetail: DataSource;
    sourceCallinScriptTemplateDetailEdit: DataSource;
    step1: Step;
    step2: Step;
    step3: Step;
    stepperCallinScript: Stepper;
    switchActive: Switch;
    switchActiveDetail: Switch;
    switchDisplayStoreValue: Switch;
    switchDisplayTotal: Switch;
    switchIncludeInputField: Switch;
    switchInputFieldRequired: Switch;
    switchRequired: Switch;
    switchRequiredDetail: Switch;
    switchUpdateField: Switch;
    tableAddedPrompts: Table;
    textbox1: Textbox;
    textboxBrokerageStatus: Textbox;
    textboxBrokerageStatusDetail: Textbox;
    textboxCallinScriptTemplateid: Textbox;
    textboxCallinScriptsTemplate: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityDetail: Textbox;
    textboxCustomer: Textbox;
    textboxCustomerDetail: Textbox;
    textboxDescription: Textbox;
    textboxDescriptionDetail: Textbox;
    textboxDetailType: Textbox;
    textboxETAtoNextStop: Textbox;
    textboxETAtoNextStopDetail: Textbox;
    textboxFieldName: Textbox;
    textboxLocationCode: Textbox;
    textboxLocationDetail: Textbox;
    textboxMode: Textbox;
    textboxMovement: Textbox;
    textboxMovementStatus: Textbox;
    textboxOrderType: Textbox;
    textboxOrderTypeDetail: Textbox;
    textboxOrderValue: Textbox;
    textboxOrderValueDesc: Textbox;
    textboxPrompt: Textbox;
    textboxResponsibility: Textbox;
    textboxResponsibilityDetail: Textbox;
    textboxResponsibiltyDescriptionDetail: Textbox;
    textboxRevenueCode: Textbox;
    textboxRevenueCodeDetail: Textbox;
    textboxStop: Textbox;
    textboxStopType: Textbox;
    textboxStopTypeDetail: Textbox;
    textboxTable: Textbox;
    textboxTrailerType: Textbox;
    textboxTrailerTypes: Textbox;
    textboxUser: Textbox;
    textboxUserDetail: Textbox;
    textboxUserEnters: Textbox;
    textboxUserGroup: Textbox;
    textboxUserGroupsDetails: Textbox;
    textboxValue: Textbox;
}
